import {Component, Input, OnInit} from '@angular/core'

@Component({
  selector: 'dmmp-form-step-details',
  templateUrl: './step-details.component.html',
})
export class StepDetailsComponent implements OnInit {
  @Input() stepsDetails
  @Input() stepActive

  constructor() {
  }

  ngOnInit() {
  }
}
